import { CheckCircleIcon } from '@heroicons/react/24/outline'
import { format } from 'date-fns'

import { CalendarEvent, RepeatingEvent } from '../../store/slices/slices.types'
import { getRelativeTimeString } from '../../lib/utils/date.utils'

export function ListCalendarEvent({
  event,
  repeatingEvent,
  calendarName,
}: {
  event: CalendarEvent
  repeatingEvent: RepeatingEvent | null
  calendarName?: string
}) {
  const eventDate = new Date(event.date)
  const relativeTime = getRelativeTimeString(eventDate)

  return (
    <li
      className={`flex items-center px-6 py-4 ${
        event.isCompleted ? 'bg-gray-50' : ''
      }`}
    >
      <div className="flex-shrink-0 w-16 text-center">
        <div
          className={`text-2xl font-bold ${
            event.isCompleted ? 'text-gray-400' : 'text-gray-900'
          }`}
        >
          {format(eventDate, 'dd')}
        </div>
        <div className="text-sm text-gray-500">{format(eventDate, 'EEE')}</div>
      </div>
      <div className="ml-4 space-y-2 flex-1">
        {!!calendarName && (
          <div className="flex flex-row items-start">
            <div className="flex flex-row bg-pink-100 rounded-lg px-2 py-1 text-xs font-medium text-gray-900">
              {calendarName}
            </div>
          </div>
        )}
        <div className="flex items-center gap-2">
          <h4
            className={`text-base font-medium ${
              event.isCompleted ? 'text-gray-400 line-through' : 'text-gray-900'
            }`}
          >
            {event.name}
          </h4>
          <span className="text-sm text-gray-500">{relativeTime}</span>
        </div>
        <div className="flex items-center gap-2">
          {repeatingEvent && (
            <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded-full">
              Repeats {repeatingEvent.repeats.rule.frequency}
            </span>
          )}
          {!!event.actions && event.actions.length > 0 && (
            <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded-full">
              {event.actions.filter((a) => a.completed).length}/
              {event.actions.length} actions
            </span>
          )}
        </div>
      </div>
      {event.isCompleted && (
        <CheckCircleIcon className="h-5 w-5 text-green-500" />
      )}
    </li>
  )
}
